<div class="receipt" (click)="show.set(!show())">
    <div class="details">
        <p class="font-light"><span class="font-bold">Service: </span> <span>{{receipt().package_name}}</span>
        </p>
        <p class="font-light"><span class="font-bold">Date: </span>{{receipt().start | date: 'd/M/yyyy'}} - {{receipt().end | date: 'd/M/yyyy'}}</p>
        <p class="font-light"><span class="font-bold">Order ID: </span>{{receipt()._id}}</p>
    </div>
    <div class="price">
        <h3 class="font-bold">€{{receipt().final_price}}</h3>
        <small><a class="font-bold">{{show() ? 'HIDE' : 'VIEW'}} RECEIPT</a></small>
    </div>
</div>
<div class="receipt-details" [@dissolve]="show()">
    @for(detail of details(); track detail.key){
        @if(detail.value){
            <div class="detail">
                <p>{{detail.key}}</p>
                <p [class.font-bold]="detail.key == 'Final Price'">{{detail.value}}</p>
            </div>
        }
    }
</div>